import { TOAST_STATE } from '@/constants';
import { Toast } from '@/types';
import { atomWithUniqueKey } from '@/utils';

export type ToastState = Toast[];

export const useToastState = atomWithUniqueKey<ToastState>({
  key: TOAST_STATE,
  default: [],
});
